import _ from 'lodash'
import axios from 'axios/dist/axios.min'

class DataService {
  constructor () {
    // this.domain = 'http://localhost:3000'
    this.domain = 'http://www.greenprosperitygroup.com:3000'
    // this.domain = 'http://120.24.200.214:3000'
  }
  // due to Publii feed.json issue, the generated id is the same as url, so we need to get an identity, current use title
  // eg. http://120.24.200.214/static/Publii/post-with-feature-image.html to post-with-feature-image
  convertURLtoID (str) {
    const from = str.lastIndexOf('/') + 1
    const to = str.lastIndexOf('.html')
    return str.slice(from, to)
  }

  getNewsList (currentPage, numPerPage) {
    return axios.get('/static/Publii/feed.json')
      .then(response => response.data.items)
      .catch(error => console.log(error))
  }

  getNewsContent (id) {
    return axios.get('/static/Publii/feed.json')
      .then(response => {
        return _.find(response.data.items, (item) => this.convertURLtoID(item.id) === id)
      })
      .catch(error => console.log(error))
  }

  joinUs (info) {
    return axios.post(`${this.domain}/joinus`, info)
      .then(response => response)
      .catch(error => console.log(error))
  }

  contactUs (info) {
    return axios.post(`${this.domain}/contact`, info)
      .then(response => response)
      .catch(error => console.log(error))
  }
}

export default new DataService()



// WEBPACK FOOTER //
// ./src/services/DataService.js